import React, { useState } from 'react';
import EmailVerification from './EmailVerification';
import CompleteRegistration from './CompleteRegistration';

const Register: React.FC = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [verifiedEmail, setVerifiedEmail] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [invitationCode, setInvitationCode] = useState('');

  const handleVerificationSuccess = (email: string, code: string, inviteCode?: string) => {
    setVerifiedEmail(email);
    setVerificationCode(code);
    setInvitationCode(inviteCode || '');
    setCurrentStep(2);
  };

  const handleBackToVerification = () => {
    setCurrentStep(1);
  };

  if (currentStep === 1) {
    return <EmailVerification onVerificationSuccess={handleVerificationSuccess} />;
  }

  return (
    <CompleteRegistration 
      email={verifiedEmail} 
      verificationCode={verificationCode}
      invitationCode={invitationCode} 
      onBack={handleBackToVerification} 
    />
  );
};

export default Register;